import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'replyTime',
  props: {
    time: { default: 0 }
  },
  setup(__props: any) {

const props = __props

const formattedTime = computed(() => {
  const totalSeconds = Number(props.time) || 0

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0')
  const seconds = String(totalSeconds % 60).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["f-ui-reply-time", __props.time > 300 ? 'error' : ''])
  }, _toDisplayString(formattedTime.value), 3))
}
}

})